export const separatePaymentDataName = (name: string) => {
  const nameParts = name.split(' ');
  const firstName = nameParts.shift() ?? ''; // Take first part of name (before first space)
  const lastName = nameParts.join(' ') ?? ''; // Take the rest of the name

  return {
    firstName,
    lastName,
  };
};
